var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portal_page",staticStyle:{"height":"100%"}},[_c('el-scrollbar',{staticClass:"scrollbar"},[_c('div',{staticClass:"place"},[_c('Header-Portal'),_vm._v(" "),_c('transition',{attrs:{"name":"scale","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('Footer')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3f6494e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/portal/doorLayout.vue
// module id = null
// module chunks = 